import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default Line.extend({
	mixins: [reactiveProp],
	props: ["chartData", "options"],
	mounted() {
		this.renderChart(this.chartData, this.options);
	}
});



// WEBPACK FOOTER //
// ./src/components/analysis/Line.js